import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import clone from 'lodash/clone';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
    getTeacherByUserId,
    openUnAssignTeachersModal,
    unassignTeachersUsingClassId,
    editTeacher,
    closeEditTeacherValidationModal,
    refreshTeacherListOnCancel,
    printClassroomStudentsSignInCard,
    closeUnassignModalRequest,
    sendPasswordLinkRequest,
    resetPasswordParams,
    sendVerificationEmailLinkRequest,
    resetValidationErrorModal
} from './actions';
import { showHideSignInCardModalRequest } from '../class-roll/actions';
import { printTeacherSignInCard } from '../teacher-roll/actions';
import EditTeacherForm from '../../components/edit-teacher-form';
import { showToast } from '../../components/toast/actions';
import messages from './messages';

export class EditTeacher extends Component {
    static propTypes = {
        selectedProduct: PropTypes.object,
        match: PropTypes.object.isRequired,
        editTeacherDetail: PropTypes.object,
        openUnAssignTeachersModal: PropTypes.func,
        unassignTeachersUsingClassId: PropTypes.func,
        getTeacherByUserId: PropTypes.func,
        isUnassignedModalOpen: PropTypes.bool,
        unassignDisableButton: PropTypes.bool,
        isLoadingEditTeacherDetail: PropTypes.bool,
        editTeacher: PropTypes.func,
        dataFilterOption: PropTypes.object,
        teacherDetail: PropTypes.object,
        teacherTitles: PropTypes.arrayOf(PropTypes.object),
        updatingTeacher: PropTypes.bool,
        showEditTeacherValidationModal: PropTypes.bool,
        editTeacherValidationMessage: PropTypes.string,
        closeEditTeacherValidationModal: PropTypes.func,
        printTeacherSignInCard: PropTypes.func,
        printClassroomStudentsSignInCard: PropTypes.func,
        isSignInCardDownloaded: PropTypes.bool,
        downloadingClassroomIds: PropTypes.object,
        refreshTeacherListOnCancel: PropTypes.func,
        showHideSignInCardModalRequest: PropTypes.func,
        closeUnassignModalRequest: PropTypes.func,
        showToast: PropTypes.func,
        sendPasswordLinkRequest: PropTypes.func,
        emailStatus: PropTypes.bool,
        emailValidationMessage: PropTypes.string,
        resetPasswordParams: PropTypes.func,
        sendVerificationEmailLinkRequest: PropTypes.func,
        intl: intlShape.isRequired,
        resetValidationErrorModal: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.handleOnUnassignTeacherUsingClassId = this.handleOnUnassignTeacherUsingClassId.bind(this);
        this.handleOnUnassignConfirm = this.handleOnUnassignConfirm.bind(this);
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this);
        this.handlePrintClassroomSignInCard = this.handlePrintClassroomSignInCard.bind(this);
        this.unassignTeachersSuccessConfirmation = this.unassignTeachersSuccessConfirmation.bind(this);
        this.state = { showUnassignTeacherModal: false, refreshListOnCancel: false };
        this.downloadingClassroomIds = new Set();
    }

    static contextTypes = {
        router: PropTypes.object
    }

    componentDidMount() {
        this.props.getTeacherByUserId(this.props.selectedProduct.id, this.props.match.params.id);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.emailStatus) {
            this.props.showToast(this.props.intl.formatMessage(messages.emailSent), 'success');
            this.props.resetPasswordParams();
        } else if (!nextProps.emailStatus && nextProps.emailValidationMessage !== '') {
            this.props.showToast(nextProps.emailValidationMessage, 'error');
            this.props.resetPasswordParams();
        } else if (nextProps.showEditTeacherValidationModal) {
            this.props.showToast(nextProps.editTeacherValidationMessage, 'error');
            this.props.resetValidationErrorModal();
        }
    }

    handleOnUnassignTeacherUsingClassId = (classId) => {
        this.setState({ showUnassignTeacherModal: true, classId });
        this.props.openUnAssignTeachersModal();
    };

    handleOnUnassignConfirm = () => {
        this.props.unassignTeachersUsingClassId(this.props.editTeacherDetail.userProfileId, this.state.classId);
    }

    handleOnCloseModal = () => {
        this.setState({ showUnassignTeacherModal: false });
        this.props.closeUnassignModalRequest();
    }

    unassignTeachersSuccessConfirmation = () => {
        this.handleOnCloseModal();
        this.setState({ refreshListOnCancel: true });
        this.props.getTeacherByUserId(this.props.selectedProduct.id, this.props.match.params.id);
    }

    handleOnEditTeacherSubmit = () => {
        const teacher = clone(this.props.teacherDetail);
        this.props.editTeacher(teacher, true, this.context);
    }

    handleOnCloseEditTeacherValidationModal = () => {
        this.props.closeEditTeacherValidationModal();
    }

    handleOnCloseEditTeacher = () => {
        this.context.router.history.push('/teachers');
        if (this.state.refreshListOnCancel === true) {
            this.props.refreshTeacherListOnCancel();
        }
    }

    handleOnPrintSignInCard = () => {
        const teacherSignInCardData = {
            teacherUserProfileIds: [this.props.match.params.id],
            SignInCardPageSizeType: 'QR_3X3'
        };
        this.props.printTeacherSignInCard(this.props.selectedProduct.id, teacherSignInCardData);
    }

    handlePrintClassroomSignInCard = (classId, SignInCardPageSizeType) => {
        this.downloadingClassroomIds.add(classId);
        this.props.printClassroomStudentsSignInCard(classId,
            this.props.selectedProduct.id,
            this.downloadingClassroomIds,
            SignInCardPageSizeType);
        this.props.showHideSignInCardModalRequest(false);
    }

    handleOnAssignClass = () => {
        const assignType = 'classToTeacher';
        this.context.router.history.push(`/assign-user/${this.props.match.params.id}/${assignType}`);
    }

    handleOnStudentSignInCards = () => {
        this.props.showHideSignInCardModalRequest(true);
    }

    handleOnCancelStudentSignInCards = () => {
        this.props.showHideSignInCardModalRequest(false);
    }

    handleOnSendTeacherPassword = () => {
        this.props.sendPasswordLinkRequest(this.props.selectedProduct.id, parseInt(this.props.match.params.id, 10));
    }

    handleOnSendEmailVerificationLink = () => {
        this.props.sendVerificationEmailLinkRequest(parseInt(this.props.match.params.id, 10));
    }

    render() {
        return (<div>
            <EditTeacherForm
                closeEditTeacher={this.handleOnCloseEditTeacher}
                closeEditTeacherValidationModal={this.handleOnCloseEditTeacherValidationModal}
                dataFilterOptions={this.props.dataFilterOption}
                downloadingClassroomIds={this.props.downloadingClassroomIds}
                editTeacherDetail={this.props.editTeacherDetail}
                editTeacherValidationMessage={this.props.editTeacherValidationMessage}
                handleOnAssignClass={this.handleOnAssignClass}
                handleOnCancelStudentSignInCards={this.handleOnCancelStudentSignInCards}
                handleOnCloseModal={this.handleOnCloseModal}
                handleOnEditTeacherSubmit={this.handleOnEditTeacherSubmit}
                handleOnPrintClassroomSignInCard={this.handlePrintClassroomSignInCard}
                handleOnPrintSignInCard={this.handleOnPrintSignInCard}
                handleOnSendEmailVerificationLink={this.handleOnSendEmailVerificationLink}
                handleOnSendTeacherPassword={this.handleOnSendTeacherPassword}
                handleOnStudentSignInCards={this.handleOnStudentSignInCards}
                handleOnUnassignConfirm={this.handleOnUnassignConfirm}
                handleOnUnassignTeacher={this.handleOnUnassignTeacherUsingClassId}
                isLoading={this.props.unassignDisableButton}
                isLoadingEditTeacherDetail={this.props.isLoadingEditTeacherDetail}
                isSignInCardDownloaded={this.props.isSignInCardDownloaded}
                isUnassignedModalOpen={this.props.isUnassignedModalOpen}
                productName={this.props.selectedProduct.name}
                showUnassignTeacherModal={this.state.showUnassignTeacherModal}
                teacher={this.props.teacherDetail}
                teacherTitles={this.props.teacherTitles}
                unassignTeachersSuccessConfirmation={this.unassignTeachersSuccessConfirmation}
                updatingTeacher={this.props.updatingTeacher}
                {...this.props}
            />
        </div>);
    }
}

const mapStateToProps = state => ({
    dataFilterOption: state.teacherRoll.dataFilterOption,
    selectedProduct: state.product,
    editTeacherReducer: state.editTeacherReducer,
    editTeacherDetail: state.editTeacher.editTeacherDetail,
    isUnassignedModalOpen: state.editTeacher.isUnassignedModalOpen,
    unassignDisableButton: state.editTeacher.unassignDisableButton,
    isLoadingEditTeacherDetail: state.editTeacher.isLoadingEditTeacherDetail,
    teacherDetail: state.editTeacher.teacherDetail,
    teacherTitles: state.teacherRoll.teacherTitles,
    updatingTeacher: state.editTeacher.updatingTeacher,
    showEditTeacherValidationModal: state.editTeacher.showEditTeacherValidationModal,
    editTeacherValidationMessage: state.editTeacher.editTeacherValidationMessage,
    isSignInCardDownloaded: state.teacherRoll.isSignInCardDownloaded,
    downloadingClassroomIds: state.editTeacher.downloadingClassroomIds,
    showHideSignInCardModal: state.classRoll.showHideSignInCardModal,
    emailStatus: state.editTeacher.emailStatus,
    emailValidationMessage: state.editTeacher.emailValidationMessage,
    enableSave: state.editTeacher.enableSave
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getTeacherByUserId,
        editTeacher,
        openUnAssignTeachersModal,
        unassignTeachersUsingClassId,
        refreshTeacherListOnCancel,
        closeEditTeacherValidationModal,
        printTeacherSignInCard,
        printClassroomStudentsSignInCard,
        showHideSignInCardModalRequest,
        closeUnassignModalRequest,
        showToast,
        sendPasswordLinkRequest,
        resetPasswordParams,
        sendVerificationEmailLinkRequest,
        resetValidationErrorModal
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EditTeacher));



// WEBPACK FOOTER //
// ./app/containers/edit-teacher/index.js